import { render, staticRenderFns } from "./notifications-page-content.vue?vue&type=template&id=2db0e44c&scoped=true"
import script from "./notifications-page-content.vue?vue&type=script&lang=js"
export * from "./notifications-page-content.vue?vue&type=script&lang=js"
import style0 from "./notifications-page-content.vue?vue&type=style&index=0&id=2db0e44c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0e44c",
  null
  
)

export default component.exports